import { Box, Circle, Text } from "@chakra-ui/react";
import { CheckIcon, CloseIcon } from '@chakra-ui/icons'

export default function ScoreTile({ question, rightAnswer, userChoice }) {
    return (
        <Box
            w='100%'
            position='relative'
            py='1rem'
            pr='1.5rem'
            d='flex'
        >
            <Box
                d='flex'
            >
                <Circle
                    size='40px'
                    bg={userChoice === rightAnswer ? '#e3fae1' : '#f5cbd0'}
                    mr='1rem'
                >
                    {userChoice === rightAnswer ? <CheckIcon height='18px' width='18px' /> : <CloseIcon height='18px' width='18px' />}
                </Circle>
            </Box>
            <Box
                d='flex'
                flexDir='column'
                style={{ gap: '0.5rem' }}
            >
                <Text
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontSize={['14px','14px','16px','18px']}
                    fontWeight='600'
                    color='#333333'
                >
                    {question}
                </Text>

                <Text
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontSize={['14px','14px','16px','18px']}
                    fontWeight='600'
                    color='#3ead34'
                >
                    Right answer: {rightAnswer}
                </Text>
                {
                    userChoice !== rightAnswer &&
                    <Text
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontSize={['14px','14px','16px','18px']}
                        fontWeight='600'
                        color='#c26771'
                    >
                        Your answer: {userChoice}
                    </Text>
                }
            </Box>
            <Box
                width='85%'
                height='1px'
                bg= '#0000001A'
                position='absolute'
                bottom='0'
                right='5'
            ></Box>
        </Box>
    )
}